import { parsePhoneNumber } from 'libphonenumber-js'

/**
 * Util function to format a phone number at a specific locale, for national calling
 * @param phone the String representing a phone number 
 * @param locale the ISO 3166-1 alpha-2 code for the locale, defaults to 'AU' if not supplied.
 */
export function resolvePhoneNumber(phone, locale = 'AU'){
  if (!validateParams(phone, locale)){
    return ''
  }
  const phoneObject = resolvePhoneNumberObject(phone, locale)

  if(phoneObject){
    return phoneObject.formatNational();
  }

  return phone
}

/**
 * Util function to format a phone number at a specific locale, for html anchor calling, i.e: `tel:0412345678`
 * @param phone the String representing a phone number 
 * @param locale the ISO 3166-1 alpha-2 code for the locale, defaults to 'AU' if not supplied.
 */
export function resolveTelephoneURI(phone, locale = 'AU'){
  if (!validateParams(phone, locale)){
    return ''
  }
  const phoneObject = resolvePhoneNumberObject(phone, locale)

  if(phoneObject){
    return phoneObject.getURI();
  }

  return `tel:${phone}`
}

function validateParams(phone, locale){
  if (typeof phone === 'string' && phone.length > 4 && phone.length < 20 
    && typeof locale === 'string' && locale.length === 2){
    return true
  }
  return false
}

function resolvePhoneNumberObject(phone, locale){  
  try{
    const phoneNumber = parsePhoneNumber(phone, locale);
    if (phoneNumber.isValid()){
      return phoneNumber
    }
  }catch(e){
    console.warn(e)
  }
  return null
}